import 'lib/canny';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './bootstrap-combined.scss';
import App from './App';
import { getUserFromSession } from 'actions/User';
import { createConfiguredStore } from './store';
import Provider from './Provider';
import * as serviceWorker from './serviceWorker';
import moment from 'moment-timezone';
/*
  Used to clear the default timezone set in polymer
  without affecting the other projects
  TODO: remove default timezone from polymer
*/
moment.tz.setDefault();

const { store, history } = createConfiguredStore();

store.dispatch(getUserFromSession());

const root = ReactDOM.createRoot(document.getElementById('root'));
const reduxDevModeCheckFrequency =
  process.env.NODE_ENV === 'development' ? 'always' : 'never';
root.render(
  <Provider
    store={store}
    history={history}
    noopCheck={reduxDevModeCheckFrequency}
  >
    <App />
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
